import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/BusinessType`;

export const GetBusinessTypeLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetBusinessTypeLookupList`
  );
  return res;
};
